import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = () => ({
	root: {
		marginBottom: 10
	}
});

@withStyles(styles)
class Header extends Component {
	render() {
		const {classes, children, className} = this.props;

		return (<Typography variant='h1' className={classNames(classes.root, className)}>{children}</Typography>);
	}
}

Header.propTypes = {
	children: PropTypes.string.isRequired,
	classes: PropTypes.object,
	className: PropTypes.string,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js